import { FavouriteProduct } from 'store/favourite/types';
import { PricesToFetch } from 'store/price/types';

const collectPricesFromFavourites = (items: FavouriteProduct[]) => {
  const result: PricesToFetch = {};

  if (!items || !items.length) {
    return result;
  }

  items.forEach((p) => {
    if (!result[p.product.categoryId]) {
      result[p.product.categoryId] = {
        categoryId: p.product.categoryId,
        productIds: [],
        encryptedDesignId: '',
      };
    }

    if (result[p.product.categoryId].productIds.indexOf(p.product.productId) < 0) {
      result[p.product.categoryId].productIds.push(p.product.productId);
    }
  });
  return result;
};

export default collectPricesFromFavourites;
